import type { RecipeCostReport } from "../../../shared/production/recipe-cost";

export function downloadRecipeCostReport(report: RecipeCostReport) {
  let objectUrl: string | null = URL.createObjectURL(new Blob([JSON.stringify(report, null, 2)], { type: "application/json" }));
  try {
    const link = document.createElement("a");
    link.href = objectUrl; link.download = `malzeme-maliyeti-${report.product.code}-${report.asOf}.json`; link.click();
    const completedUrl = objectUrl;
    window.setTimeout(() => URL.revokeObjectURL(completedUrl), 1000); objectUrl = null;
  } finally {
    if (objectUrl) URL.revokeObjectURL(objectUrl);
  }
}
